/**
 * Asynchronously loads the component for PiecripMarketPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripMarketPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripMarketPage
);
